import "../../components/atoms/buttons/button.scss";
import { memo, useEffect, useRef, useState } from "react";
import React from "react";
import "./../login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import "./misActosAdmin.scss";
import DataTable from "react-data-table-component";
import { getDatosAdicionales, getListaVidaAdmin } from "../../components/services/VidaAdministrativaService";
import ConstantesTabla from "../../utils/ConstantesTabla";
import { useNavigate } from "react-router-dom";
import { SpinnerCircle, SpinnerCircleMini } from "../../components/atoms/spinner/Spinner";
import ModalDetalleAdicional from "../../components/molecules/modals/modalsVidaAdministrativa/ModalDetalleAdicional";


const MisActosAdmin = () => {
  const [listadoVidaAdm, setListadoVidaAdm] = useState()
  const [loading, setLoading] = useState(false);
  const [loadingDatosAdicionales, setLoadingDatosAdicionales] = useState(null);
  const [loadingResolucion, setLoadingResolucion] = useState(null);
  const [showDetalle, setShowDetalle] = useState(false);
  const [detalle, setDetalle] = useState();
  const navigate = useNavigate();
  const abortControllerRef = useRef(null);

  // const handleShowDetalle = () => {
  //   setShowDetalle(!showDetalle);
  // };

  const handleCloseDetalle = (e) => {
    setShowDetalle(false);
  };

  const handleGetDatosAdicionales = (xsolactadm, dacto) => {
    setDetalle()
    // Cancelamos cualquier petición previa
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setLoadingDatosAdicionales(xsolactadm);

    getDatosAdicionales(xsolactadm, controller.signal)
      .then((data) => {
        if (controller.signal.aborted || !data) return; // no hacer nada si se canceló
        setLoadingDatosAdicionales(null);
        navigate(`/misActosAdmin/${xsolactadm}/datosAdicionales`, {
          state: { detalle: data?.DETALLE, dacto },
        });
      })
      .catch((err) => {
        if (err.name !== "CanceledError" && err.name !== "AbortError") {
          // console.error(err);
        }
        setLoadingDatosAdicionales(null);
      });
  };

  // ✅ Cancelamos si el componente se desmonta
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);



  const handleGetResolucion = (xsolactadm, dactadm) => {
    setLoadingResolucion(xsolactadm); // Activa el spinner solo en esa fila
    navigate(`/misActosAdmin/${xsolactadm}/resolucion?dactadm=${dactadm}`);
  };

  const acciones = [
    {
      name: "Datos Adicionales",
      selector: (row) => (<>

        {
          row.DATOS_ADI === "S" && (
            <>
              {loadingDatosAdicionales === row.X_CABACTADM ? (
                <div className="row my-1 mx-auto py-1 px-auto">
                  <div className="col"><SpinnerCircleMini /></div>
                </div>
              ) : (
                <div
                  className="cursorPointer row p-1 m-1"
                  onClick={() => handleGetDatosAdicionales(row.X_CABACTADM, row.D_ACTADM)}
                  tabIndex={0}
                  role="link"
                  title={`Ver datos adicionales de ${row.D_ACTADM}`}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleGetDatosAdicionales(row.X_CABACTADM, row.D_ACTADM);
                    }
                  }}
                >
                  <div className="col">Ver</div>
                </div>
              )}
            </>
          )
        }


      </>),

      grow: 1.5,
      wrap: true,
    },
    {
      name: "",
      selector: (row) => (<>
        {
          row.RESOLUCION === "S" && (
            <>
              {loadingResolucion === row.X_CABACTADM ? (
                <SpinnerCircleMini />
              ) : (
                <div
                  className="cursorPointer m-1 py-1 px-3"
                  onClick={() => handleGetResolucion(row.X_CABACTADM, row.D_ACTADM)}
                  tabIndex={0}
                  role="link"
                  title="Ver resolución"
                  aria-label="Ver resolución de mis actos administrativos"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleGetResolucion(row.X_CABACTADM, row.D_ACTADM);
                    }
                  }}
                >
                  <div>Ver Resolución</div>
                </div>
              )}
            </>
          )
        }

      </>),
      grow: 1.5,
      wrap: true,
    },
  ]

  const [filtro, setFiltro] = useState("");
  const [listaFiltrada, setListaFiltrada] = useState([]);

  useEffect(() => {
    if (listadoVidaAdm) {
      const resultado = listadoVidaAdm.filter(item =>
        item.D_ACTADM.toLowerCase().includes(filtro.toLowerCase())
      );
      setListaFiltrada(resultado);
    }
  }, [filtro, listadoVidaAdm]);

  useEffect(() => {
    setLoading(true)
    getListaVidaAdmin().then((data) => {
      setListadoVidaAdm(data.VIDADM);
      
      setLoading(false)
    })
  }, [])

  function MisActosAdmin() {
    return (
      <>
        <Header />
        <div className="container contenedorMisActos" role="main" data-landmark-index="4">
          <div className="misActos row">
            {/*<Titulo
              tipo={"tituloModal"}
              titulo={"Mis Actos Administrativos"}
            />*/}

            <h2 className="tituloAccesibilidadMini">Consulta de mis Actos Administrativos</h2>
            <div className="row mt-1">
              <div className="col-md-3 position-relative">
                <input
                  type="text"
                  className="form-control pe-5"
                  placeholder="Buscar acto administrativo..."
                  value={filtro}
                  onChange={(e) => setFiltro(e.target.value)}
                />
                <i
                  className="fa fa-search position-absolute"
                  style={{
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#aaa",
                    pointerEvents: "none"
                  }}
                ></i>
              </div>
            </div>

            <div className="tablaMisActos col">
              {!loading ? (<>
                <DataTable
                  className="table-reponsive"
                  columns={[...ConstantesTabla.columnasVidaAdm, ...acciones]}
                  data={listaFiltrada}
                  pagination={false}
                  paginationComponentOptions={
                    ConstantesTabla.paginacionOpt
                  }
                  noDataComponent={
                    <span className="rojo">No hay Actos disponibles</span>
                  }
                  customStyles={ConstantesTabla.customStyles2}

                />
              </>) : (<><div><SpinnerCircle /></div></>)}

            </div>
            <div className="gridBotones mb-2">
              <button
                id="volver"
                className="btnRed rounded btnCancelarDocumentacion"
                type="button"
                onClick={() => navigate("/home")}
              >
                <i className="fa-solid fa-rotate-left"></i> Volver
              </button>
            </div>
          </div>
          {showDetalle ? (<>
            {}
            <ModalDetalleAdicional
              show={showDetalle}
              handleClose={handleCloseDetalle}
              titulo="Error al recuperar el PDF"
              tipo="tituloBorrador rojo"
              detalle={detalle}
            /></>) : null}
        </div>
        <Footer />

      </>
    );
  }

  return <>{MisActosAdmin()}</>;
};

export default memo(MisActosAdmin);
